import { defineMessages } from 'react-intl';

export const pendingTeamInviteModalMessages = defineMessages({
  declineFailed: {
    defaultMessage: "Couldn't ignore the invite. Please try again.",
    id: '6XNzlXbjDm',
    description:
      'Error toast shown when declining a pending team invitation fails, so the user knows the prompt is still waiting on them',
  },
});
